// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1RiTF","header":"MergedInvoice_header__1B4r6"};